// ============================================================================
// 이슈 상세 추적성 섹션 (CHG-047: REQ-V47-009)
// ============================================================================

import { Network, ArrowUp, ArrowDown } from 'lucide-react';
import { useIssueTraceChain } from '../../hooks/useTraceability';

interface Props {
  projectId: string;
  issueId: string;
}

export default function IssueTraceSection({ projectId, issueId }: Props) {
  const { data: chain } = useIssueTraceChain(projectId, issueId);

  if (!chain) return null;

  const { upstream, downstream } = chain;
  const hasUpstream = !!upstream.requirement;
  const hasDownstream = downstream.branches.length > 0 || downstream.pullRequests.length > 0 ||
    downstream.commits.length > 0 || downstream.testCases.length > 0;

  if (!hasUpstream && !hasDownstream) return null;

  return (
    <div className="border-t border-gray-100 px-5 py-3">
      <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-2 flex items-center gap-1.5">
        <Network className="size-3.5" /> 추적성
      </h4>

      {/* Upstream */}
      {hasUpstream && (
        <div className="mb-2">
          <div className="flex items-center gap-1 text-[11px] text-gray-400 mb-1">
            <ArrowUp className="size-3" /> 상위 요구사항
          </div>
          <div className="ml-4 text-sm">
            <span className="font-medium text-blue-600">{upstream.requirement!.reqId}</span>
            <span className="text-gray-600 ml-1">{upstream.requirement!.title}</span>
            <span className={`ml-2 px-1.5 py-0.5 text-[11px] rounded ${
              upstream.requirement!.status === 'APPROVED' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'
            }`}>{upstream.requirement!.status}</span>
          </div>
        </div>
      )}

      {/* Downstream: Test Cases */}
      {downstream.testCases.length > 0 && (
        <div>
          <div className="flex items-center gap-1 text-[11px] text-gray-400 mb-1">
            <ArrowDown className="size-3" /> 테스트 케이스 ({downstream.testCases.length})
          </div>
          <div className="ml-4 space-y-1">
            {downstream.testCases.map((tc) => (
              <div key={tc.testCaseId} className="flex items-center gap-2 text-sm">
                <span>{tc.lastResult === 'PASS' ? '✅' : tc.lastResult === 'FAIL' ? '❌' : '⬜'}</span>
                <span className="text-gray-700">{tc.title}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
